'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.dayAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/dayAgo.js
// module id = 324
// module chunks = 1